export default __webpack_public_path__ + "static/media/009-caution.a5b188e5.png";